import newAPIClient from '../api/newApi';

export const getMarkers = (id: string): Promise<void | any> => {
  return newAPIClient.get(`trend-spotter/markers?id=${id}`).then((res: any) => {
    return res.data.data;
  });
};
